/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для попапа о минимальной сумме заказа
   */
  app.minSumOrderPopupView = app.View.extend({
    el: '#continue_shopping',
    additionalOptions: ['orderConditions'],
    /**
     * @inheritDoc
     */
    run: function () {
      this.createMinSumPopupView();

      this.checkoutPopupTemplate = app.helpers.TemplateHelper.getTemplate('#checkout-popup');

      this.listenTo(this.cart, 'update', this.updateSum);
      this.listenTo(this.cart, 'currency-set', this.updateSum);
      this.listenTo(this.orderConditions, 'sync', this.updateSum);
      this.listenTo(Backbone, 'update-min-sum-popup', this.updateSum);
      this.updateSum();
    },

    /**
     * Создание попапа
     */
    createMinSumPopupView: function () {
      var minSumPopup = $('[data-popup-id="checkout"]');
      this.minSumPopup = new als.Popup(minSumPopup);
      this.minSumPopup.addEventListener(
        als.Popup.EventType.BEFORE_OPEN,
        function () {
          var top = $(window).scrollTop() + ($(window).height() - minSumPopup.outerHeight(true)) / 2,
            left = ($(window).width() - minSumPopup.width()) / 2;
          if (app.isMobile) {
            left = 0;
            top = ($(window).height() / 2);
          }
          minSumPopup.css({
            left: left,
            top: top,
          });
        }
      );
    },

    /**
     * Открываем попап
     */
    open: function () {
      // Без таймаута лебедевскй попап сразу закрывается
      setTimeout(this.minSumPopup.open.bind(this.minSumPopup), 0);
    },

    /**
     * Закрываем попап
     */
    close: function () {
      this.minSumPopup.close();
    },

    /**
     * Обновление информации в попапе.
     */
    updateSum: function () {
      var minOrderSum = this.orderConditions.get('min_order_sum');
      var isExclusion = this.cart.isExclusion;
      var cityName = this.settlement.get('name');

      if (typeof this.checkoutPopupTemplate === 'function') {
        this.$('.popup-minsum_sum').replaceWith(this.checkoutPopupTemplate({
          minSumOrder: app.helpers.NumberHelper.fractionNumber(minOrderSum)[0],
          isExclusion: isExclusion,
          cityName: cityName,
          currentCurrency: this.cart.currency,
        }));
      }
      Backbone.trigger('min-sum-popup-updated');
    },
  });
})(jQuery);

}.call(window));